
import wx from 'weixin-js-sdk'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
components: {
wx,XTextarea,Group
},
data() {
return {
subStatus: true,
popUp: false,
rechargePop: false,
orderShow: false,
clotheShow: false,
colorShow: false,
flawShow: false,
bagCode:'',
amount:'',
order_no:'',
type:0,
order: {
community:{
name:''
},
},
name:'',
phone:'',
froms:[
{
code:'',
clothe_id:0,
color_id:0,
flaw_id:[],
clothe:'选择衣物',
flaw:'选择瑕疵',
color:'选择颜色',
filePath: [],
pics:[],
remark:'',
}
],
clotheIndex:0,
colorIndex:0,
flawIndex:0,
picIndex:0,
clothes: [],
colors: [],
flaws: [],
info:{}
}
},
created() {
this.type = Number(this.$route.params.type);
this.order_no = this.$route.params.order_no;
if(this.order_no || this.type > 1){
this.getOrder();
}
this.config();
},
mounted(){
this.getInfo();
},
methods: {
getInfo(){
this.$api.getInfo({}).then((res)=>{
if(res){
this.info = res.data;
}
})
},
addModules(){
this.froms.push({
code:'',
clothe_id:0,
color_id:0,
flaw_id:[],
clothe:'选择衣物',
flaw:'选择瑕疵',
color:'选择颜色',
filePath: [],
pics:[],
});
},
removeModules(index){
this.froms.splice(index, 1);
},
scanQRCode(key,index){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ['barCode'],
success: function (res) {
setTimeout(()=>{
if(key > 0){
that.froms[index].code = that.$func.parseScanResult(res.resultStr);
}else{
that.bagCode = that.$func.parseScanResult(res.resultStr);
that.getOrder();
}
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
getOrder() {
this.$api.getRecordOrder({code:this.bagCode,order_no:this.order_no,type:this.type}).then((res)=>{
if(res){
this.clothes = res.data.goods;
this.colors = res.data.colors;
this.flaws = res.data.flaw;
if(this.type <= 1){
this.order = res.data.order;
this.popUp = true;
this.orderShow = true;
}
}
})
},
getLastUserInfo() {
this.$api.getLastUserInfo({}).then((res)=>{
if(res){
this.name = res.data.name;
this.phone = res.data.phone;
}
})
},
openClotheShow(index){
this.clotheIndex = index;
this.popUp = true;
this.clotheShow = true;
},
openClotheColor(index){
this.colorIndex = index;
this.popUp = true;
this.colorShow = true;
},
openClotheFlaw(index){
this.flawIndex = index;
this.popUp = true;
this.flawShow = true;
},
closePop(){
this.popUp = false;
this.rechargePop = false;
this.orderShow = false;
this.clotheShow = false;
this.colorShow = false;
this.flawShow = false;
this.clotheIndex = 0;
this.colorIndex = 0;
this.flawIndex = 0;
this.amount = 0;
},
clotheSelect(id,title){
this.froms[this.clotheIndex].clothe_id = id;
this.froms[this.clotheIndex].clothe = title;
this.closePop();
},
colorSelect(id,title){
this.froms[this.colorIndex].color_id = id;
this.froms[this.colorIndex].color = title;
this.closePop();
},
flawSelect(i,title){
let flawId = this.froms[this.flawIndex].flaw_id;
if(flawId){
if(flawId.indexOf(i) > -1){
flawId.splice(flawId.indexOf(i),1);
this.froms[this.flawIndex].flaw_id = flawId;
}else{
this.froms[this.flawIndex].flaw_id.push(i);
}
}else{
this.froms[this.flawIndex].flaw_id.push(i);
}
let flaw = this.froms[this.flawIndex].flaw_id;
this.froms[this.flawIndex].flaw = '';
flaw.forEach((item,index)=>{
this.froms[this.flawIndex].flaw += (index == flaw.length-1 ? this.flaws[item].title : this.flaws[item].title+',');
});
if(this.froms[this.flawIndex].flaw_id.length < 1){
this.froms[this.flawIndex].flaw = '选择瑕疵';
}
},
submit() {
if(!this.subStatus){
return false;
}
console.log(this.froms);
this.$api.submitRecord({order_id:this.order.id,cid:this.order.cid,name:this.name,phone:this.phone,record_type:this.type,clothe:JSON.stringify(this.froms)}).then((res)=>{
if(res){
this.$func.showToast('提交成功');
this.subStatus = true;
this.order_no = '';
setTimeout(()=>{
window.location.reload();
},300);
}
})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"chooseImage",
"uploadImage",
"scanQRCode"
]
});
}
})
},
uploadFile(index){
let that = this;
this.picIndex = index;
wx.chooseImage({
count: 9,
sizeType: ['original', 'compressed'],
sourceType: ['album', 'camera'],
success: function (res) {
that.uploadImg(res.localIds);
}
});
},
uploadImg(localIds){
let that = this;
let localId = localIds.pop();
wx.uploadImage({
localId: localId,
success: function (res) {
that.$api.uploadsImgOss({serverId:res.serverId,path:'record'}).then((res)=>{
if(res){
that.froms[that.picIndex].filePath.push(res.data.pathName);
that.froms[that.picIndex].pics.push(res.data.saveName);
if(localIds.length > 0){
that.uploadImg(localIds);
}
}
})
}
});
},
showPic(i,index) {
wx.previewImage({
current: this.froms[i].filePath[index],
urls: [this.froms[i].filePath[index]]
});
},
delImg(i,index){
this.froms[i].filePath.splice(index,1);
this.froms[i].pics.splice(index,1);
},
openRecharge(){
this.rechargePop = true;
this.popUp = true;
},
recharge(){
if(this.amount <= 0){
this.$func.showToast('请输入充值金额');
return false;
}
if (typeof WeixinJSBridge == "undefined"){
if( document.addEventListener ){
document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
}else if (document.attachEvent){
document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
}
}else{
this.onBridgeReady();
}
},
onBridgeReady(){
let that = this;
this.$api.recharge({money:this.amount}).then((res)=>{
if(res){
WeixinJSBridge.invoke(
'getBrandWCPayRequest', res.data,
function(res){
if(res.err_msg == "get_brand_wcpay_request:ok" ){
that.$func.showToast('支付成功');
setTimeout(()=>{
that.getInfo();
},300);
}else{
that.$func.showToast('已取消支付');
}
that.closePop();
}
);
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/bagCodeRecord.vue